<template>
  <div id="pageRoot">
    <span class="normalTheme pageInstruction" style="left: 67px; top: 130px;">
      <p>Escribe el nombre de cada animal.</p>
    </span>

    <img src="/pages/img/sordovio/assets_p26/titulo.svg" style="position: absolute; width: 570px; top: 10px; left: 50px;" class="hover-animation-a" />
    <img src="/pages/img/sordovio/assets_p26/nube2.svg" style="position: absolute; width: 200px; top: 180px; left:440px; z-index: 1"  class="slideItemB"/>

    <img src="/pages/img/sordovio/assets_p26/nube1.svg" style="position: absolute; width: 170px; top: 180px; left:340px; z-index: 0"  class="slideItem"/>

    <img src="/pages/img/sordovio/assets_p26/arboles.svg" style="position: absolute; width: 340px; top: 130px; left: 620px; z-index: -1" class="slideItem"/>

    <img src="/pages/img/sordovio/assets_p26/lago.svg" style="position: absolute; width: 990px; top: 280px; left: 20px;"/>

    <img src="/pages/img/sordovio/assets_p26/rana.svg" style="position: absolute; width: 120px; top: 370px; left: 90px; z-index: 2" class="basicItem02"/>

    <img src="/pages/img/sordovio/assets_p26/tero.svg" style="position: absolute; width: 180px; top: 530px; left: 90px; z-index: 2" class="basicItem01"/>

    <img src="/pages/img/sordovio/assets_p26/grillo.svg" style="position: absolute; width: 110px; top: 380px; left: 290px; z-index: 2" class="basicItem02"/>

    <img src="/pages/img/sordovio/assets_p26/guitarrero.svg" style="position: absolute; width: 160px; top: 380px; left: 550px; z-index: 2" class="basicItem01"/>

    <img src="/pages/img/sordovio/assets_p26/chicharra.svg" style="position: absolute; width: 140px; top: 620px; left: 510px; z-index: 2" class="basicItem02"/>

    <img src="/pages/img/sordovio/assets_p26/pajaro.svg" style="position: absolute; width: 190px; top: 350px; left: 770px; z-index: 2" class="hover-animation-a" />

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputFrog"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputGrillo"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputGuitarrero"
    />

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputTero"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputChicharra"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputCardenal"
    />
  </div>
</template>
<style scoped>
#inputFrog {
  position: absolute;
  width: 228px;
  height: 31px;
  left: 54px;
  top: 306px;
}
#inputGrillo {
  position: absolute;
  width: 228px;
  height: 31px;
  left: 265px;
  top: 520px;
}
#inputGuitarrero {
  position: absolute;
  width: 228px;
  height: 31px;
  left: 537px;
  top: 480px;
}
#inputTero {
  position: absolute;
  width: 228px;
  height: 31px;
  left: 200px;
  top: 620px;
}
#inputChicharra {
  position: absolute;
  width: 228px;
  height: 31px;
  left: 522px;
  top: 700px;
}
#inputCardenal {
  position: absolute;
  width: 228px;
  height: 31px;
  left: 762px;
  top: 600px;
  z-index: 3;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["vio/Video 90.mp4", "vio/Video 91_1.mp4"]
    }
  }
}
</script>